import React from 'react';
import { Link } from 'react-router';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';

import {DropdownButton,MenuItem} from 'react-bootstrap';

class Pager extends React.Component {

  render() {
    const {intl} = this.props;
    const t = (message, data = {}) => {
        return intl.formatMessage({id : message}, data);
    };
    const { loading } = this.props;
    return (
       <ul className="pager">
          <li><button onClick={this.props.prevClick} className="btn-brand btn btn-default btn-round" disabled={loading || this.props.pageIndex <= 1}><span aria-hidden="true">&larr;</span> {t('Previous')}</button></li>
          <li> {this.props.pageIndex} / {this.props.totalPageCount} </li>
          <li><button onClick={this.props.nextClick} className="btn-brand btn btn-default btn-round" disabled={loading || this.props.pageIndex >= this.props.totalPageCount}>{t('Next')} <span aria-hidden="true">&rarr;</span></button></li>
          {
            /*<li> <DropdownButton title={t('Page size')} id="dd-page-size" className="btn-brand btn btn-default">
                  <MenuItem eventKey="50">50</MenuItem>
                  <MenuItem eventKey="100">100</MenuItem>
                  <MenuItem eventKey="500">500</MenuItem>
                  <MenuItem eventKey="1000">1000</MenuItem>
                </DropdownButton>
          </li>*/
          }
       </ul>
    );
  }
}

Pager.displayName = 'Pager';
Pager.propTypes = {
    pageIndex: React.PropTypes.number.isRequired,
    totalPageCount: React.PropTypes.number.isRequired,
    loading : React.PropTypes.bool,
    nextClick : React.PropTypes.func,
    prevClick : React.PropTypes.func
};
Pager.defaultProps = {
    loading : false
};

export default injectIntl(Pager);



// WEBPACK FOOTER //
// ./components/Shared/Pager.js